import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { CustomerModel, Provider as Customer } from '@/store/types/work/Providers';

export const NAMESPACE = 'work/enterprises/customers';

const state: RootState = {
  status: null,
  items: [],
  item: {},
  meta: undefined
};

const getters: GetterTree<RootState, any> = {
  items: state => state.items,
  meta: state => state.meta,
  loading: state => state.status === null,
  status: state => state.status,
  item: state => state.item
};

const actions: ActionTree<RootState, any> = {
  request: ({ commit, dispatch, rootGetters }:any, filter:any = {}) => {
    filter = {
      'filters[order_by]': 'title',
      ...filter
    };
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise.id}/customers`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  show: ({ commit, state, rootGetters }:any, id:number) => {
    state.items.forEach((c:Customer) => {
      if (c.id === id) {
        commit('setCustomer', c);
      }
    });
    commit('request');
    let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
    (new Http()).request({
      url: `enterprise/${enterprise.id}/customers/${id}`
    })
      .then((resp:any) => {
        commit('successShow', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  storeRequest: ({ commit, rootGetters }:any, data:Customer) => {
    let validData = {
      title: data.title
    };
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      let url = data.id
        ? `enterprise/${enterprise.id}/customers/${data.id}`
        : `enterprise/${enterprise.id}/customers`;
      (new Http()).request({ url: url, data: validData, method: 'POST' })
        .then((resp:any) => {
          if (resp.data.data) {
            commit('successStore', { resp: data, update: !!data.id });
          }
          resolve(resp.data.data);
        })
        .catch((e:any) => {
          commit('error');
          reject(e);
        });
    });
  }
};

const mutations: MutationTree<RootState> = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state, resp) => {
    state.status = true;
    if (resp.data) {
      state.items = [];
      resp.data.forEach((item: Customer) => {
        state.items.push(new CustomerModel(item));
      });
    }
    state.meta = resp.meta;
  },
  successShow: (state:any, resp:any) => {
    state.status = true;
    state.item = new CustomerModel(resp.data);
    state.meta = resp.meta;
  },
  setCustomer: (state:any, resp:any) => {
    state.item = resp.data;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.customers.length; i++) {
        if (state.customers[i].id === resp.id) {
          state.customers[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.customers[state.customers.length] = resp;
      }
    } else {
      state.customers[state.customers.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
